module.exports = __webpack_public_path__ + "fonts/9b3766e.woff2";